/** @format */
import angular from 'angular';
import _ from 'lodash';

export const validationResultModule = 'sis-components.bulkedit.validationResult';

(function () {
    angular
        .module(validationResultModule, [])
        .factory('ValidationResult', ValidationResult)
        .constant('ValidationPhase', {
            NOT_STARTED: 'BULK_EDIT.VALIDATION.NOT_STARTED',
            NOT_READY: 'BULK_EDIT.VALIDATION.NOT_READY',
            FAILED: 'BULK_EDIT.VALIDATION.FAILED',
            READY: 'BULK_EDIT.VALIDATION.READY',
            ACTIONS_READY: 'BULK_EDIT.VALIDATION.ACTIONS_READY',
        })
        .constant('ValidationResponse', {
            BACK_END_FORBIDDEN: 'BULK_EDIT.VALIDATION.ERROR.BACK_END_FORBIDDEN',
            BACK_END_VALIDATION_ERROR: 'BULK_EDIT.VALIDATION.ERROR.BACK_END_VALIDATION_ERROR',
            BACK_END_NOT_FOUND: 'BULK_EDIT.VALIDATION.ERROR.BACK_END_NOT_FOUND',
            VALIDATION_ALREADY_IN_CURRICULUMPERIOD: 'BULK_EDIT.VALIDATION.ERROR.ALREADY_IN_CURRICULUMPERIOD',
        });

    function ValidationResult() {
        return function (status) {
            this.status = status;

            this.validationResults = {};

            this.haveErrors = [];
            this.noErrors = [];
            this.summary = {
                errors: {},
                infos: {},
            };

            this.addInfo = function (validationTarget, resultType) {
                if (_.indexOf(this.noErrors, validationTarget) === -1) {
                    this.noErrors.push(validationTarget);
                }
                updateSummary(this.summary.infos, resultType);
                return saveResult(this.validationResults, validationTarget, resultType);
            };

            this.addError = function (validationTarget, resultType) {
                if (_.indexOf(this.haveErrors, validationTarget) === -1) {
                    this.haveErrors.push(validationTarget);
                }
                updateSummary(this.summary.errors, resultType);
                return saveResult(this.validationResults, validationTarget, resultType);
            };

            this.infoSummary = function () {
                return curValidationStatusList(this.summary.infos);
            };

            this.errorSummary = function () {
                return curValidationStatusList(this.summary.errors);
            };

            function saveResult(validationResults, jsDataObject, resultType) {
                const result = {
                    info: resultType,
                    details: [],
                    changes: [],
                    addDetail(field, value) {
                        this.details.push({ field, value });
                        return this;
                    },
                    addChange(field, oldValue, newValue) {
                        this.changes.push({ field, oldValue, newValue });
                        return this;
                    },
                };

                if (validationResults[jsDataObject.id]) {
                    validationResults[jsDataObject.id].push(result);
                } else {
                    validationResults[jsDataObject.id] = [result];
                }

                return result;
            }

            function updateSummary(summary, resultType) {
                if (summary[resultType]) {
                    summary[resultType]++;
                } else {
                    summary[resultType] = 1;
                }
            }

            function curValidationStatusList(summary) {
                return _.map(_.keys(summary), curValidationStatus => ({ type: curValidationStatus, count: summary[curValidationStatus] }));
            }
        };
    }
})();
